<template>
  <div class="text-tertiary text-sm flex justify-between">
    <span>{{ t("components.character_count.max", maxChars) }}</span>
    <span>{{ charCount }}/{{ maxChars }}</span>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";

defineProps({
  maxChars: Number,
  charCount: Number,
});

const { t } = useI18n();
</script>
